import { notifyFromFlax, notifyInternal } from "./internal.notify";
import { FxNotificationPayload, FxNotificationType, NotificationId, NotificationPayload } from "./type";

export function notify(payload: NotificationPayload): NotificationId;

export function notify(payload: FxNotificationPayload, severity: FxNotificationType): NotificationId;

export function notify(payload: NotificationPayload | FxNotificationPayload, severity?: FxNotificationType): NotificationId {
  if (typeof payload === "string") {
    return notifyFromFlax(payload, severity as FxNotificationType);
  }

  return notifyInternal(payload);
}
